import React from 'react';

import { Search } from './components/Search';
import { ITagsProps, Tags } from './components/Tags';
import styles from './list-header.module.scss';

export interface IListHeaderProps extends ITagsProps {}

export const HeadingWithFilters = ({ handleFiltersChange, filters, rubric }: IListHeaderProps) => {
  return (
    <div className={styles.headerWrapper}>
      <div className={styles.searchWrapper}>
        <Search handleFiltersChange={handleFiltersChange} filters={filters} />
      </div>
      <Tags handleFiltersChange={handleFiltersChange} filters={filters} rubric={rubric} />
    </div>
  );
};
